module.exports = __webpack_public_path__ + "static/triton-1-08895f7c4bfc6df8b2590392ed5b2198.webp";